import { components } from '@/utils'

export default function(h) {
  if (this.isFinalStatus) {
    return null
  }

  return h(
    components['list-item'],
    {
      props: {
        label: this.label,
        icon: this.icon,
        iconColor: this.iconColor,
        dense: true,
        loading: this.loading,
        disabled: this.disabled
      },
      on: {
        click: () => {
          this.toggle()
        }
      }
    }
  )
}
